import script from "./SocialPacket.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialPacket.vue?vue&type=script&setup=true&lang=ts"
/* custom blocks */
import block0 from "./SocialPacket.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__